export default "__VITE_ASSET__76599588__"